import { ApplicationRef, Component, Inject, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

import { getReferrer, handleLastClickTracking, languages } from './shared/constants/app-enums';
import { DOCUMENT } from '@angular/common';
import { environment } from '../environments/environment';

declare global {
  interface Window {
    dataLayer: any[];
  }
}
export var selectedLang: string;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  canRender: boolean = true;

  constructor(
    @Inject(DOCUMENT) private dom: Document,
    private meta: Meta,
    private title: Title,
    private translate: TranslateService,
  ) {
    inject(ApplicationRef).isStable.subscribe((isStable) => (this.canRender = isStable || this.canRender));

    handleLastClickTracking(['clickId', 'source', 'tid', 'pid']);
    getReferrer();
    let base = environment.domain;

    this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      selectedLang = params.lang;
      const metaData = this.translate.instant('misc.meta_data');
      const metaTitle = this.translate.instant('misc.meta_title');
      this.title.setTitle(metaTitle);
      this.meta.updateTag({ name: 'description', content: metaData });
      this.meta.updateTag({ name: 'hreflang', content: selectedLang });

      const link: HTMLLinkElement | null = this.dom.querySelector('link[rel=canonical]');
      const hrefValue = selectedLang === 'en' ? base : base + '/' + selectedLang;

      if (link) {
        link.href = hrefValue;
      } else {
        const newLink = this.dom.createElement('link');
        newLink.rel = 'canonical';
        newLink.href = hrefValue;
        this.dom.head.appendChild(newLink);
      }
      const existingLinks = this.dom.querySelectorAll('link[rel="alternate"]');
      existingLinks.forEach((link: Element) => link.remove());
      for (let lang of languages) {
        const newLink = this.dom.createElement('link');
        newLink.rel = 'alternate';
        newLink.hreflang = lang.value;
        newLink.href = lang.value === 'en' ? base : `${base}/${lang.value}`;
        // Append new <link> to the <head>
        this.dom.head.appendChild(newLink);
      }
      const newLink = this.dom.createElement('link');
      newLink.rel = 'alternate';
      newLink.hreflang = 'x-default';
      newLink.href = `${base}`;
      // Append new <link> to the <head>
      this.dom.head.appendChild(newLink);
      this.dom.documentElement.lang = selectedLang; //making html lang dynamic for SEO
    });
  }
}
